<script>
import DropDown from '../reUse/DropDown.vue';
import Notification from '../reUse/Notification.vue';
import { i18n } from '@/i18n'
import { config } from '@/config'
import sl from '@/Prevodi/Jadralna_beri-sl.json';
import en from '@/Prevodi/Jadralna_beri-en.json';
import it from '@/Prevodi/Jadralna_beri-it.json';
export default {
  components: {
    DropDown,
    Notification
  },
  props: {
    PodatkiObracun: Object,
    PodatkiNezakljuceni: Object,
    user: Object,
  },
  emits: ['datumo', 'datumk', 'osvezi'],
  data() {
    return {
      prevodi: false,
      datumO: new Date().toISOString().split('T')[0],
      datumD: new Date().toISOString().split('T')[0],
      pilotName: '',
      filterPilot: '',
      filterLetalo: '',
      filterInstruktor: '',
      instructorName: '',
      regLetala: '',
      IzbranNamen: '',
      IzbranaNaloga: '',
      krajVzleta: 'LJAJ',
      krajPristanka: 'LJAJ',
      poletanje: '',
      casOdklopa: '',
      casVleke: '',
      pristanek: '',
      // kilometri: '',
      regVleka: '',
      opomba: '',
      //motorni let
      pilotNameM: '',
      pristanekM: '',
      IzbranNamenM: '',
      IzbranaNalogaM: 'Vleka',
      dPilot: false,
      dPilotM: false,
      dLetalo: false,
      dInstruktor: false,
      dFiltri: false,
      dNamen: false,
      dNamenM: false,
      dNaloga: false,
      dPristanek: false,
      dVzlet: false,
      Letala: [],
      LetalaMotorna: [],
      dLetaloVleka: false,
      Piloti: [],
      PilotiV: [],
      Instruktor: [],
      Letalisca: [],
      namen: [
        {id: 0, namen: 'Trenažni let'},
        {id: 1, namen: 'Kontrolni let'},
        {id: 2, namen: 'Osnovno šolanje'},
        {id: 3, namen: 'Šolanje za poob.'},
        {id: 4, namen: 'Tekmovalni let'},
        {id: 5, namen: 'Izpitni let'},
        {id: 6, namen: 'Preizkusni let'},
        {id: 7, namen: 'Uvodni let'},
        {id: 8, namen: 'Protipožarni let'},
        {id: 9, namen: 'AK'},
      ],
      naloga: [
        {id: 0, naloga: 'Šolski krog'},
        {id: 1, naloga: 'Prelet'},
        {id: 2, naloga: 'Let v rajonu'},
        {id: 3, naloga: 'Ruta'},
      ],
      podatkiIzbris: {},
      // PodatkiObracuna: [],
      izbranZapis: [],
      urejanje: false,
      idUrejanja: '',
      idUrejanjaM: '',
      sortAscending: true,
      text: '',
      types: '',
      ShowNoti: false,
      pravice: [],
      praviceUrejanja: false,
      praviceUrejanjaVseh: false,
      praviceBrisanja: false,
      praviceBrisanjaVseh: false,
      pot: config.baseUrl,
      sending: false,
      exporting: false,
      printing: false,
      dniPregleda: null,
      dodajam: false
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetLetala();
    this.GetPiloti();
    this.GetLetalisca();
    this.GetPravice();
    if(config.UserLVL === 2) {
      this.NastavitevPregleda();
    }
    // this.GetPodatkiObracuna();
  },
  computed: {
    FiltriraniPodatki() {
      if (this.filterPilot !== '') {
        if (this.filterLetalo !== '') {
          if (this.filterInstruktor !== '') {
            return this.PodatkiObracun.filter(zapis => zapis.registracija === this.filterLetalo && zapis.pilot === this.filterPilot && zapis.instruktor === this.filterInstruktor);
          } else {
            return this.PodatkiObracun.filter(zapis => zapis.registracija === this.filterLetalo && zapis.pilot === this.filterPilot);
          }
        }
        if (this.filterInstruktor !== '') {
          return this.PodatkiObracun.filter(zapis => zapis.pilot === this.filterPilot && zapis.instruktor === this.filterInstruktor);
        } else {
          return this.PodatkiObracun.filter(zapis => zapis.pilot === this.filterPilot);
        }

      }
      if (this.filterLetalo !== '') {
        if (this.filterInstruktor !== '') {
          return this.PodatkiObracun.filter(zapis => zapis.registracija === this.filterLetalo && zapis.instruktor === this.filterInstruktor);
        } else {
          return this.PodatkiObracun.filter(zapis => zapis.registracija === this.filterLetalo);
        }
      }
      if (this.filterInstruktor !== '') {
        return this.PodatkiObracun.filter(zapis => zapis.instruktor === this.filterInstruktor);
      }
      return this.PodatkiObracun;
    },
    FilterVlecnihPilotov() {
      return this.PilotiV.piloti.filter(pilot => pilot.vlecni_rating === 1);
    },
  },
  methods: {
    OpenView(id) {
      this.izbranZapis = this.PodatkiObracun.filter(p => p.id === id);
      $(this.$refs.modalObracunMotZapisa).modal('show');
    },
    OpenViewZ(id) {
      this.izbranZapis = this.PodatkiNezakljuceni.filter(p => p.id === id);
      this.UrediZapis(id);
      $(this.$refs.modalObracunOdprti).modal('show');
      setTimeout(() => {
        $(this.$refs.pristanekZ).focus();
      }, 200);
    },
    DetailsOff() {
      $(this.$refs.modalObracunMotZapisa).modal('hide');
      //ponastavitev podatkov urejanja
      this.pilotName = '';
      this.instructorName = '';
      this.regLetala = '';
      this.IzbranNamen = '';
      this.IzbranaNaloga = '';
      this.krajVzleta = '';
      this.krajPristanka = '';
      this.poletanje = '';
      this.casOdklopa = '';
      this.casVleke = '';
      this.pristanek = '';
      // kilometri: '',
      this.regVleka = '';
      this.opomba = '';
      //motorni let
      this.pilotNameM = '';
      this.pristanekM = '';
      this.urejanje = false;
    },
    DetailsOffZ() {
      $(this.$refs.modalObracunOdprti).modal('hide');
      this.pristanek = '';
      this.urejanje = false;
    },
    UrediZapis(id) {
      this.idUrejanja = id;
      this.idUrejanjaM = this.izbranZapis[0].id_motorno;
      this.urejanje = true;
      this.pilotName = this.izbranZapis[0].pilot;
      this.instructorName = (this.izbranZapis[0].instruktor == null) ? '' : this.izbranZapis[0].instruktor;
      this.regLetala = this.izbranZapis[0].registracija;
      this.IzbranNamen = this.izbranZapis[0].namen;
      this.IzbranaNaloga = this.izbranZapis[0].naloga;
      this.krajVzleta = this.izbranZapis[0].kraj_vzleta;
      this.krajPristanka = this.izbranZapis[0].kraj_pristanka;
      this.poletanje = this.izbranZapis[0].cas_vzleta;
      this.casOdklopa = this.izbranZapis[0].cas_odklopa;
      this.casVleke = this.izbranZapis[0].cas_vleke;
      this.pristanek = (this.izbranZapis[0].cas_pristanka == null) ? '' : this.izbranZapis[0].cas_pristanka;
      // kilometri: '',
      this.regVleka = this.izbranZapis[0].reg_vleke;
      this.opomba = this.izbranZapis[0].opomba;
      //motorni let
      this.pilotNameM = this.izbranZapis[0].pilot_vleke;
      this.pristanekM = this.izbranZapis[0].cas_pristanka_vleka;
      this.IzbranNamenM = 'vleka';
    },
    PosodobiZapis() {
      if (this.pilotName !== '' && this.regLetala !== '' && this.IzbranNamen !== '' && this.IzbranaNaloga !== '' && this.krajVzleta !== '' && this.krajPristanka !== '' && this.poletanje !== '' && this.pristanek !== '') {
        this.dodajam = true;
        let app = this;
        let dodaj = new URLSearchParams();
        //preverjanje časa, da ni v prihodnosti
        const datumDanes = new Date().toISOString().split('T')[0];
        if (this.izbranZapis[0].datum === datumDanes) {
          let cas = new Date();
          cas.setHours(cas.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
          cas.setMinutes(cas.getMinutes() + 15); //dovolimo 15 minut v prihodnost
          cas = cas.toISOString().split('T')[1].split('.')[0];
          let casP = new Date();
          casP.setHours(casP.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
          casP = casP.toISOString().split('T')[1].split('.')[0];
          if (this.poletanje > casP || this.pristanek > cas) {
            // alert("Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!");
            app.text = app.$t('obvestila.zapisCasPrihodnost');
            app.types = "Napaka";
            app.ShowNoti = true;
            return;
          }
        }
        dodaj.append('uID', app.idUrejanja);
        dodaj.append('uID_motorja', app.idUrejanjaM);
        dodaj.append('pilot', app.pilotName);
        dodaj.append('pilotM', app.pilotNameM);
        dodaj.append('instruktor', app.instructorName);
        dodaj.append('reg_letala', app.regLetala);
        dodaj.append('namen', app.IzbranNamen);
        dodaj.append('naloga', app.IzbranaNaloga);
        dodaj.append('kraj_vzleta', app.krajVzleta);
        dodaj.append('kraj_pristanka', app.krajPristanka);
        dodaj.append('poletanje', app.poletanje);
        dodaj.append('cas_odklopa', app.casOdklopa);
        dodaj.append('cas_vleke', app.casVleke);
        dodaj.append('pristanek', app.pristanek);
        dodaj.append('pristanekM', app.pristanekM);
        // dodaj.append('kilometri', app.kilometri);
        dodaj.append('reg_vleke', app.regVleka);
        dodaj.append('opomba', app.opomba);
        dodaj.append('p_logbook_jadralna_id', app.izbranZapis[0].p_logbook_jadralna_id);
        dodaj.append('datum', app.izbranZapis[0].datum);
        axios
            .post("./api/log/jadralno/uredi/", dodaj, {withCredentials: true})
            .then((response) => {
              this.dodajam = false;
              //reaktivna posodobitev podatkov pilota
              this.izbranZapis[0].pilot = this.pilotName;
              this.izbranZapis[0].instruktor = this.instructorName;
              this.izbranZapis[0].registracija = this.regLetala;
              this.izbranZapis[0].namen = this.IzbranNamen;
              this.izbranZapis[0].naloga = this.IzbranaNaloga;
              this.izbranZapis[0].kraj_vzleta = this.krajVzleta;
              this.izbranZapis[0].kraj_pristanka = this.krajPristanka;
              this.izbranZapis[0].cas_vzleta = this.poletanje;
              this.izbranZapis[0].cas_odklopa = this.casOdklopa;
              this.izbranZapis[0].cas_vleke = response.data.vleka;
              this.izbranZapis[0].cas_pristanka = this.pristanek;
              this.izbranZapis[0].reg_vleke = this.regVleka;
              this.izbranZapis[0].opomba = this.opomba;
              this.izbranZapis[0].pilot_vleke = this.pilotNameM;
              this.izbranZapis[0].cas_pristanka_vleka = this.pristanekM;
              this.$emit('osvezi');
              //ponastavitev vrednosti
              this.pilotName = '';
              this.instructorName = '';
              this.regLetala = '';
              this.IzbranNamen = '';
              this.IzbranaNaloga = '';
              this.krajVzleta = '';
              this.krajPristanka = '';
              this.poletanje = '';
              this.casOdklopa = '';
              this.casVleke = '';
              this.pristanek = '';
              this.regVleka = '';
              this.opomba = '';
              this.pilotNameM = '';
              this.pristanekM = '';
              this.urejanje = false;
              // alert('Posodobitev uspešna');
              this.text = this.$t('obvestila.posodobitevUspesna');
              this.types = "Uspešno";
              this.ShowNoti = true;

            })
            .catch((napaka) => {
              this.dodajam = false;
              if (napaka.response.status === 401) {
                this.$router.push('/Logout');
              }
              if (napaka.response.data.napaka !== undefined) {
                // this.text = 'Napaka pri posodabljanju podatkov. '+napaka.response.data.napaka;
                this.text = this.$t('obvestila.napakaPosodabljanja');
              } else {
                this.text = this.$t('obvestila.napakaPosodabljanja');
              }
              this.types = 'Napaka';
              this.ShowNoti = true;
            })
      } else {
        this.text = this.$t('obvestila.napakaVnosa');
        this.types = "Napaka";
        this.ShowNoti = true;
      }
    },
    ZakljuciLet() {
      if (this.pristanek !== '') {
        this.dodajam = true;
        let app = this;
        let dodaj = new URLSearchParams();
        //preverjanje časa, da ni v prihodnosti
        let cas = new Date();
        cas.setHours(cas.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
        cas.setMinutes(cas.getMinutes() + 15); //dovolimo 15 minut v prihodnost
        cas = cas.toISOString().split('T')[1].split('.')[0];
        let casP = new Date();
        casP.setHours(casP.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
        casP = casP.toISOString().split('T')[1].split('.')[0];
        const datumDanes = new Date().toISOString().split('T')[0];
        if (this.izbranZapis[0].datum === datumDanes) {
          if (this.poletanje > casP || this.pristanek > cas) { //"časovna omejtiev" velja samo za tekoči datum
            // alert("Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!");
            this.dodajam = false;
            app.text = app.$t('obvestila.zapisCasPrihodnost');
            app.types = "Napaka";
            app.ShowNoti = true;
            return;
          }
        }
        if (this.pristanek < this.poletanje) {
          this.dodajam = false;
          app.text = app.$t('obvestila.napakaPristanka');
          app.types = "Napaka";
          app.ShowNoti = true;
          return;
        }
        dodaj.append('uID', app.idUrejanja);
        dodaj.append('uID_motorja', app.idUrejanjaM);
        dodaj.append('pilot', app.pilotName);
        dodaj.append('pilotM', app.pilotNameM);
        dodaj.append('instruktor', app.instructorName);
        dodaj.append('reg_letala', app.regLetala);
        dodaj.append('namen', app.IzbranNamen);
        dodaj.append('naloga', app.IzbranaNaloga);
        dodaj.append('kraj_vzleta', app.krajVzleta);
        dodaj.append('kraj_pristanka', app.krajPristanka);
        dodaj.append('poletanje', app.poletanje);
        dodaj.append('cas_odklopa', app.casOdklopa);
        dodaj.append('cas_vleke', app.casVleke);
        dodaj.append('pristanek', app.pristanek);
        dodaj.append('pristanekM', app.pristanekM);
        // dodaj.append('kilometri', app.kilometri);
        dodaj.append('reg_vleke', app.regVleka);
        dodaj.append('opomba', app.opomba);
        dodaj.append('p_logbook_jadralna_id', app.izbranZapis[0].p_logbook_jadralna_id);
        dodaj.append('datum', app.izbranZapis[0].datum);
        axios
            .post("./api/log/jadralno/uredi/", dodaj, {withCredentials: true})
            .then((response) => {
              this.dodajam = false;
              //reaktivna posodobitev podatkov pilota
              this.izbranZapis[0].pilot = this.pilotName;
              this.izbranZapis[0].instruktor = this.instructorName;
              this.izbranZapis[0].registracija = this.regLetala;
              this.izbranZapis[0].namen = this.IzbranNamen;
              this.izbranZapis[0].naloga = this.IzbranaNaloga;
              this.izbranZapis[0].kraj_vzleta = this.krajVzleta;
              this.izbranZapis[0].kraj_pristanka = this.krajPristanka;
              this.izbranZapis[0].cas_vzleta = this.poletanje;
              this.izbranZapis[0].cas_odklopa = this.casOdklopa;
              this.izbranZapis[0].cas_vleke = response.data.vleka;
              this.izbranZapis[0].cas_pristanka = this.pristanek;
              this.izbranZapis[0].reg_vleke = this.regVleka;
              this.izbranZapis[0].opomba = this.opomba;
              this.izbranZapis[0].pilot_vleke = this.pilotNameM;
              this.izbranZapis[0].cas_pristanka_vleka = this.pristanekM;
              this.$emit('osvezi');
              //ponastavitev vrednosti
              this.pilotName = '';
              this.instructorName = '';
              this.regLetala = '';
              this.IzbranNamen = '';
              this.IzbranaNaloga = '';
              this.krajVzleta = '';
              this.krajPristanka = '';
              this.poletanje = '';
              this.casOdklopa = '';
              this.casVleke = '';
              this.pristanek = '';
              this.regVleka = '';
              this.opomba = '';
              this.pilotNameM = '';
              this.pristanekM = '';
              this.urejanje = false;
              // alert('Posodobitev uspešna');
              this.text = this.$t('obvestila.letZakljucen');
              this.types = "Uspešno";
              this.ShowNoti = true;
              this.DetailsOffZ();

            })
            .catch((napaka) => {
              this.dodajam = false;
              if (napaka.response.status === 401) {
                this.$router.push('/Logout');
              }
              if (napaka.response.data.napaka !== undefined) {
                this.text = this.$t('obvestila.letNiZakljucen');
              } else {
                this.text = this.$t('obvestila.letNiZakljucen');
              }
              this.types = 'Napaka';
              this.ShowNoti = true;
            })
      } else {
        this.text = this.$t('obvestila.napakaPrazenPristanek');
        this.types = "Napaka";
        this.ShowNoti = true;
      }
    },
    PotrdiIzbris(id, idLb, idMotorno) {
      this.podatkiIzbris = {
        id: id,
        idLb: idLb,
        idMotorno: idMotorno
      };
      this.text = this.$t('obvestila.vprasanjeIzbris');
      this.types = "Vprašanje";
      this.ShowNoti = true;
    },
    izbrisiZapis() {
      this.dodajam = true;
      let text = this.$t('obvestila.vprasanjeIzbris');
      // BRISANJE
      let app = this;
      let izbris = new URLSearchParams();
      izbris.append("id_brisanja", this.podatkiIzbris.id);
      izbris.append("id_brisanja_lb", this.podatkiIzbris.idLb);
      izbris.append("id_motorno", this.podatkiIzbris.idMotorno);
      axios
          .post("./api/log/jadralno/brisi/", izbris)
          .then(function (response) {
            this.dodajam = false;
            text = app.$t('obvestila.zapisPobrisan');
            app.$emit('osvezi');
            app.DetailsOff();
            app.podatkiIzbris = {};
            // alert(text);
            app.text = text;
            app.types = "Uspešno";
            app.ShowNoti = true;
          })
          .catch((napaka) => {
            this.dodajam = false;
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              // this.text = 'Napaka pri izbrisu podatkov. '+napaka.response.data.napaka;
              this.text = this.$t('obvestila.napakaIzbrisa');
            } else {
              this.text = this.$t('obvestila.napakaIzbrisa');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPravice() {
      if (this.user.lvl > 1) {
        var podatki = new URLSearchParams();
        podatki.append('uID', this.user.id);
        podatki.append('menuID', '1');
        axios.post('./api/uporabniki/pravice/izpis/', podatki, {withCredentials: true}).then((response) => {
          this.pravice = response.data.pravice;
          this.PreveriPravice(this.pravice);
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = this.$t('obvestila.napakaBranja');
          } else {
            this.text = this.$t('obvestila.napakaBranja');
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      } else { //če je user lvl 0 ali 1 ima avtomatsko pravice urejanja in brisanja
        this.praviceUrejanja = true;
        this.praviceUrejanjaVseh = true;
        this.praviceBrisanja = true;
        this.praviceBrisanjaVseh = true;
      }
    },
    PreveriPravice(pravice) { //nastavljanje pravic uporabnika za branje in brisanje
      for (var i = 0; i < pravice.length; i++) {
        switch (pravice[i].za) { //switch case glede na poslane pravice
          case 'urejanje':
            this.praviceUrejanja = pravice[i].omogoceno;
            break;
          case 'urejanje_vse':
            this.praviceUrejanjaVseh = pravice[i].omogoceno;
            break;
          case 'brisanje':
            this.praviceBrisanja = pravice[i].omogoceno;
            break;
          case 'brisanje_vse':
            this.praviceBrisanjaVseh = pravice[i].omogoceno;
            break;
          default:
            // default ni nastavljen
        }
      }
    },
    LahkoUreja() { //preverjanje pravic urejanja, če lahko uporabnik določen zapis ureja
      var danes = new Date().toISOString().split('T')[0].split('-').reverse();
      danes = danes[0] + '.' + danes[1] + '.' + danes[2];
      if (this.praviceUrejanjaVseh || this.user.lvl <= 3) { //preverjanje pravic urejanja vseh zapisov
        return true;
      } else if (this.izbranZapis[0].vnesel === Number(this.user.id) && this.izbranZapis[0].datum === danes) { //preverjanje pravic urejanja lastnih zapisov
        //preverjanje, če je lastnik zapisa prijavljen uporabnik
        return true;
      } else {
        return false;
      }
    },
    LahkoBrise() {
      if (this.praviceBrisanjaVseh) {//preverjanje pravic brisanja vseh zapisov
        return true;
      } else if (this.praviceBrisanja) {//preverjanje pravic brisanja lastnih zapisov
        if (this.izbranZapis[0].vnesel === Number(this.user.id)) {//preverjanje, če je lastnik zapisa prijavljen uporabnik
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    LahkoZakljuci() {
      var danes = new Date().toISOString().split('T')[0].split('-').reverse();
      danes = danes[0] + '.' + danes[1] + '.' + danes[2];
      if (this.user.lvl > 1) {
        if (this.user.lvl > 3) {
          if (this.izbranZapis[0].vnesel === Number(this.user.id) || this.izbranZapis[0].sifra_poizvedovalec === this.izbranZapis[0].pilot) {
            if (this.izbranZapis[0].datum === danes || this.izbranZapis[0].sifra_poizvedovalec === this.izbranZapis[0].pilot) { //če gre za pilota preverjamo, če je zapis od danes
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          //dodano, da lahko kronometrist zaključi
          return true;
        }
        if (this.izbranZapis[0].datum === danes) { //če gre za kronometrista preverjamo, če je zapis od danes
          return true;
        } else {
          return false;
        }
      } else if (this.user.lvl < 1) {
        return true;
      }
    },
    GetLetalisca() {
      let app = this;
      axios
          .get("./api/sifranti/letalisca/beri/")
          .then(function (response) {
            app.Letalisca = response.data;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            for (let i = 0; i < response.data.letala.length; i++) {
              if (response.data.letala[i].vrsta_letala === 'Jadralno') {
                app.Letala.push(response.data.letala[i]);
              } else if (response.data.letala[i].vrsta_letala === 'Motorno') {
                app.LetalaMotorna.push(response.data.letala[i]);
              }
            }
            app.LetalaMotorna = app.LetalaMotorna.filter(letalo => letalo.vlecno === true); //dodano filtriranje za prikaz samo letal, ki so označena za vleko
            // alert("Zapis uspešno dodan!");
            // app.LetalaMotorna = response.data;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPiloti() {
      let app = this;
      axios
          .get("./api/sifranti/piloti/izpis/")
          .then(function (response) {
            // alert("Zapis uspešno dodan!");
            if (app.user.lvl < 4) {
              app.Piloti = response.data;
              app.PilotiV = response.data;
            } else {
              app.PilotiV = response.data;
              app.Piloti.piloti = response.data.piloti.filter(pilot => pilot.email === app.user.email);
            }
            // app.Instruktor = response.data.piloti.map(pilot => pilot.instruktor);
            app.Instruktor = response.data.piloti.filter(pilot => pilot.instruktor_jadralno === true && pilot.datum_izbrisa == null);
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPodatkiObracuna() {
      this.$emit("datumo", this.datumO);
      this.$emit("datumk", this.datumD);
      this.$emit('osvezi');
    },
    GetCasVleke() {
      var podatki = new URLSearchParams();
      podatki.append('poletanje', this.poletanje);
      podatki.append('datum', this.datum);
      podatki.append('reg_vleke', this.regVleka);
      axios.post('./api/log/motorno/izpis/', podatki, {withCredentials: true}).then((response) => {
        this.casVleke = response.data.cas_vleke;
        // if(response.data.cas_vleke == null) {
        //     this.casVleke = "00:00";
        //     alert('Pozor! Izbrano letalo za vleko nima zapisanega časa letenja! Preverite, da ste izbrali pravilno registracijo letala, drugače bo zapisan čas vleke 00:00!');
        // }
        setTimeout(() => {
          this.Add();
        }, 200);
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = this.$t('obvestila.napakaBranja');
        } else {
          this.text = this.$t('obvestila.napakaBranja');
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    ToogleSort() {
      this.sortAscending = !this.sortAscending;
      this.PodatkiObracun.reverse();
      this.PodatkiNezakljuceni.reverse();
    },
    selectPilot(id) {
      let pilot = this.Piloti.piloti.find(p => p.id === id);
      if (pilot) {
        // this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.pilotName = pilot.sifra;
        this.dPilot = false;
      }
    },
    selectPilotM(id) {
      let pilot = this.PilotiV.piloti.find(p => p.id === id);
      if (pilot) {
        // this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.pilotNameM = pilot.sifra;
        this.dPilotM = false;
      }
    },
    selectPilotF(id) {
      let pilot = this.Piloti.piloti.find(p => p.id === id);
      if (pilot) {
        this.filterPilot = pilot.sifra;
        this.dPilot = false;
      }
    },
    selectInstructor(id) {
      let instruktor = this.Piloti.piloti.find(ins => ins.id === id);
      if (instruktor) {
        this.instructorName = instruktor.ime + ' ' + instruktor.priimek;
        this.dInstruktor = false;
      }
    },
    selectInstructorF(id) {
      let instruktor = this.Piloti.piloti.find(ins => ins.id === id);
      if (instruktor) {
        this.filterInstruktor = instruktor.ime + ' ' + instruktor.priimek;
        this.dInstruktor = false;
      }
    },
    selectLetalo(id) {
      // let letalo = this.Letala.letala.find(l => l.id === id);
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        this.regLetala = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
      }
    },
    selectLetaloF(id) {
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        this.filterLetalo = letalo.registracija;
        this.dLetalo = false;
      }
    },
    selectNamen(id) {
      let namen = this.namen.find(n => n.id === id);
      if (namen) {
        this.dNamen = false;
        this.IzbranNamen = namen.namen;
      }
    },
    selectNamenM(id) {
      let namen = this.namen.find(n => n.id === id);
      if (namen) {
        this.dNamenM = false;
        this.IzbranNamenM = namen.namen;
      }
    },
    selectNaloga(id) {
      let naloga = this.naloga.find(na => na.id === id);
      if (naloga) {
        this.dNaloga = false;
        this.IzbranaNaloga = naloga.naloga;
      }
    },
    selectLetaloVleke(id) {
      let motorno = this.LetalaMotorna.find(mo => mo.id === id);
      if (motorno) {
        this.regVleka = motorno.registracija;
        this.dLetaloVleka = false; // Zapri dropdown po izbiri
      }
    },
    selectPristanek(id) {
      let pristanek = this.Letalisca.letalisca.find(pr => pr.id === id);
      if (pristanek) {
        this.dPristanek = false;
        this.krajPristanka = pristanek.icao;
      }
    },
    selectVzlet(id) {
      let vzlet = this.Letalisca.letalisca.find(vl => vl.id === id);
      if (vzlet) {
        this.dVzlet = false;
        this.krajVzleta = vzlet.icao;
      }
    },
    EmptyLetaloVleka() {
      this.regVleka = '';
    },
    OpenPilot() {
      this.dPilot = !this.dPilot;
    },
    OpenPilotM() {
      this.dPilotM = !this.dPilotM;
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    OpenInstructor() {
      this.dInstruktor = !this.dInstruktor;
    },
    OpenNamen() {
      this.dNamen = !this.dNamen;
    },
    OpenNamenM() {
      this.dNamenM = !this.dNamen;
    },
    OpenNaloga() {
      this.dNaloga = !this.dNaloga;
    },
    OpenVzlet() {
      this.dVzlet = !this.dVzlet;
    },
    OpenPristanek() {
      this.dPristanek = !this.dPristanek;
    },
    OpenMotorna() {
      this.dLetaloVleka = !this.dLetaloVleka;
    },
    sestejCase() {
      let skupneMinute = 0;
      let skupneUre = 0;
      for (let i = 0; i < this.FiltriraniPodatki.length; i++) {
        // Pretvori oba časa v minute
        var [ure, minute] = this.FiltriraniPodatki[i].cas_letenja.split(':').map(Number);
        skupneMinute += minute;
        skupneUre += ure;
      }
      while (skupneMinute >= 60) {
        skupneMinute -= 60;
        skupneUre++;
      }
      // Formatiraj nazaj v HH:MM
      const ureStr = String(skupneUre).padStart(2, '0');
      const minuteStr = String(skupneMinute).padStart(2, '0');

      return `${ureStr}:${minuteStr}`;
    },
    SestejPristanke() {
      let pristanki = 0;
      for (let i = 0; i < this.FiltriraniPodatki.length; i++) {
        // Pretvori oba časa v minute
        pristanki += this.FiltriraniPodatki[i].st_pristankov;
      }
      return pristanki;
    },
    CalculateFlights() { // TEGA NE POTREBUJEMO VEČ - PUŠČAM SAMO ZA INFO
      let AllFlightsTime = '00:00';
      for (let i = 0; i < this.PodatkiObracun.length; i++) {

        this.AllFlightsTime = this.sestejCase(AllFlightsTime, this.PodatkiObracun[i].cas_letenja);
      }
    },
    NatisniIzpise() {
      this.printing = true;
      var podatki = new URLSearchParams();
      podatki.append('zapisiJ', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/pdf/', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
        this.printing = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.printing = true;
      });
    },
    IzvozCSV() {
      this.exporting = true;
      var podatki = new URLSearchParams();
      podatki.append('zapisiJ', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/csv/', podatki, {withCredentials: true}).then((response) => {
        window.open(this.pot + response.data.datoteka);
        this.exporting = false;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.exporting = false;
      });
    },
    SendToMail() {
      this.sending = true;
      var podatki = new URLSearchParams();
      podatki.append('zapisiJ', JSON.stringify(this.FiltriraniPodatki));
      podatki.append('datumO', this.datumO);
      podatki.append('datumD', this.datumD);
      axios.post('./api/log/pdf/', podatki, {withCredentials: true}).then((response) => {
        var podatkiMail = new URLSearchParams();
        podatkiMail.append('datoteka', response.data.datoteka);
        podatkiMail.append('zadeva', 'Izpisek jadralnih letov');
        podatkiMail.append('osebno', true);
        axios.post('./api/log/mail/', podatkiMail, {withCredentials: true}).then((response) => {
          // alert(response.data.sporocilo);
          this.text = (response.data.sporocilo);
          this.types = "Uspešno";
          this.ShowNoti = true;
          this.sending = false;
        }).catch((napaka) => {
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = 'Napaka pri pošiljanju podatkov. ' + napaka.response.data.napaka;
          } else {
            this.text = 'Napaka pri pošiljanju podatkov.';
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
          this.sending = false;
        });
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri pridobivanju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri pridobivanju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
        this.sending = false;
      });
    },
    async NastavitevPregleda() {
      await axios.get('./api/nastavitve/pregled/').then((response) => {
        this.dniPregleda = response.data.dni;
      }).catch((error) => {
        //TODO
      });
    },
    NastaviDatum() {
      let datum = new Date();
      datum.setDate(datum.getDate() - this.dniPregleda);

      return datum.toISOString().split('T')[0];
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <div class="container p-2" v-if="prevodi">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da="izbrisiZapis" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
    </Transition>
    <div class="">
      <h4 class="text-white">
        {{$t('main.title')}} &nbsp;
        <button class="btn btn-sm btn-outline-secondary" @click.prevent="ToogleSort()"><i class="fas" :class="{'fa-chevron-up' : sortAscending, 'fa-chevron-down' : !sortAscending}"></i></button></h4>
      <!-- NEZAKLJUČENI -->
      <section class="flight-section-pregled mt-2" v-if="PodatkiNezakljuceni.length > 0">

        <div class="section-header">
          <div class="section-icon motor">
            <i class="fas fa-paper-plane"></i>
          </div>
            <div>
              <h2>{{ $t('table.titleJ') }}</h2>
              <span>{{ PodatkiNezakljuceni.length }} zapisov</span>
            </div>
            <div class="d-flex col-md-8 justify-content-center">
              <h2 class="text-danger"> {{ $t('main.nezakljuceni') }}</h2>
            </div>
        </div>

        <div class="flight-list">

          <div
              class="flight-item-pregled"
              v-for="(id, index) in PodatkiNezakljuceni"
              @click.prevent="OpenViewZ(id.id)"
          >

            <div class="flight-date">
              <i class="fas fa-paper-plane"></i>
              <span>{{ id.registracija }}</span>
            </div>

            <div class="flight-task">
              <span class="label-flight">{{$t('table.datum')}}</span>
              <strong>{{ id.datum.substring(0,5) }}</strong>
            </div>
            <div class="flight-user">
              <span class="label-flight">{{$t('table.vzlet')}} <i class="fas" :class="{'fa-sort-up' : sortAscending, 'fa-sort-down' : !sortAscending}"></i></span>
              <strong>{{ id.cas_vzleta }}</strong>
            </div>

            <div class="flight-task">
              <span class="label-flight">{{$t('table.pilot')}}</span>
              <strong>{{ id.pilot }}</strong>
            </div>

            <div class="flight-task">
              <span class="label-flight">{{$t('table.naloga')}}</span>
              <strong>{{ id.naloga }}</strong>
            </div>

            <div class="flight-action">
              <i class="fas fa-chevron-right"></i>
            </div>

          </div>

          <div v-if="!PodatkiNezakljuceni.length" class="empty-state">
            <i class="far fa-folder-open"></i>
            <span>Ni podatkov</span>
          </div>

        </div>

      </section>
      <!-- ZAKLJUČENI -->
      <div class="col-12">
        <div class="container">
          <div class="label-date p-2 col-6">{{$t('labels.datumOd')}}</div>
          <input class="input border-0 rounded-4 p-2 fs-5"
                 type="date"
                 :max="(this.user.lvl <= 1 || this.user.lvl > 3) ? '' : new Date().toISOString().split('T')[0]"
                 :min="(this.user.lvl === 2) ? NastaviDatum() : ''"
                 id="datum"
                 v-model="datumO"
                 required
                 @change="GetPodatkiObracuna"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="container">
          <div class="label-date p-2 col-6">{{$t('labels.datumDo')}}</div>
          <input class="input border-0 rounded-4 p-2 fs-5"
                 :disabled="this.user.lvl > 2 && this.user.lvl < 4"
                 type="date" id="datum"
                 v-model="datumD"
                 :min="(this.user.lvl === 2) ? NastaviDatum() : ''"
                 required
                 @change="GetPodatkiObracuna" />
        </div>
      </div>
      <!-- FILTRI -->
      <div v-if="this.user.lvl <=4">
        <div class="hr-with-text">Filtriranje podatkov</div>
        <!-- PILOT FILTER -->
        <div class="col-12">
          <div class="container">
            <label class="label-dropdown" for="filterPilot">{{$t('labels.pilotJ')}} <button v-if="filterPilot !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="filterPilot = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
            <div class="drop-down-icon text-black" @click.prevent="OpenPilot()" >
              <i v-show="!dPilot" class="fas fa-chevron-right"></i>
              <i v-show="dPilot" class="fas fa-chevron-down"></i>
            </div>
            <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="filterPilot" @click.prevent="OpenPilot">{{filterPilot}}</button>
            <transition name="fade">
              <drop-down @pilot="selectPilotF" :data="Piloti" type="piloti" class="drop-down-btn" v-if="dPilot" />
            </transition>
          </div>
        </div>
        <!-- INŠTRUKTOR FILTER -->
        <div class="col-12">
          <div class="container">
            <label class="label-dropdown" for="filterInstruktor">{{$t('labels.instruktor')}} <button v-if="filterInstruktor !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="filterInstruktor = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
            <div class="drop-down-icon text-black" @click.prevent="OpenInstructor()">
              <i v-show="!dInstruktor" class="fas fa-chevron-right"></i>
              <i v-show="dInstruktor" class="fas fa-chevron-down"></i>
            </div>
            <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="filterInstruktor" @click.prevent="OpenInstructor">{{filterInstruktor}}</button>
            <transition name="fade">
              <drop-down @instruktor="selectInstructorF" :data="Instruktor" type="instruktor" class="drop-down-btn" v-if="dInstruktor" />
            </transition>
          </div>
        </div>
        <!-- LETALO FILTER -->
        <div class="col-12">
          <div class="container">
            <label class="label-dropdown" for="filterLetalo">{{$t('labels.registracijaJ')}}<button v-if="filterLetalo !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="filterLetalo = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
            <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()" >
              <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
              <i v-show="dLetalo" class="fas fa-chevron-down"></i>
            </div>
            <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="filterLetalo" @click.prevent="OpenLetalo">{{filterLetalo}}</button>
            <transition name="fade">
              <drop-down @letalo="selectLetaloF" :data="Letala" type="letalo" class="drop-down-btn" v-if="dLetalo" />
            </transition>
          </div>
        </div>
      </div>
      <!-- /FILTRI -->
      <!-- IZPIS -->
      <div v-if="this.user.lvl <=4">
        <h4 class="text-white">{{$t('data.title')}}</h4>
        <div class='row'>
          <div class='col-5'>
            <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.exporting" @click.prevent="IzvozCSV" data-umami-event="Jadralna-zapisi-csv">{{$t('buttons.csv')}}<i class="fas fa-file-csv" :class="{'fa-spin' : this.exporting}"></i></button>
          </div>
          <div class='col-4'>
            <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.printing" @click.prevent="NatisniIzpise" data-umami-event="Jadralna-zapisi-tisk">{{$t('buttons.natisni')}} <i class="fas fa-print" :class="{'fa-spin' : this.printing}"></i></button>
          </div>
          <div class='col-3 text-center'>
            <button class='btn btn-sm btn-outline-warning' :disabled="!FiltriraniPodatki.length > 0 || this.sending" @click.prevent="SendToMail" data-umami-event="Jadralna-zapisi-email">{{$t('buttons.poslji')}} <i class="far fa-envelope" :class="{'fa-spin' : this.sending}"></i></button>
          </div>
        </div>
      </div>
      <!-- /IZPIS -->
    </div>
    <!-- ZAKLJUČENI LETI -->
    <section class="flight-section-pregled mt-2">

      <div class="section-header">
        <div class="section-icon motor">
          <i class="fas fa-paper-plane"></i>
        </div>
        <div class="d-flex col-10 justify-content-between">
          <div>
            <h2>{{ $t('table.titleJ') }}</h2>
            <span>{{ FiltriraniPodatki.length }} zapisov</span>
          </div>
          <div >
            <h2 class="text-success"> {{ $t('main.zakljuceni') }}</h2>
          </div>
          <div>
            <h2>{{ $t('data.casVZraku') }}</h2>
            <span> {{ this.sestejCase() }} </span>
          </div>
        </div>
      </div>

      <div class="flight-list">

        <div
            class="flight-item-pregled"
            v-for="(id, index) in FiltriraniPodatki"
            @click.prevent="OpenView(id.id)"
        >
          <div class="flight-task">
            <span class="label-flight">{{$t('table.datum')}}</span>
            <strong>{{ id.datum.substring(0,5) }}</strong>
          </div>
          <div class="flight-date">
            <i class="fas fa-paper-plane"></i>
            <span>{{ id.registracija }}</span>
          </div>

          <div class="flight-user">
            <span class="label-flight">{{$t('table.vzlet')}} <i class="fas" :class="{'fa-sort-up' : sortAscending, 'fa-sort-down' : !sortAscending}"></i></span>
            <strong>{{ id.cas_vzleta }}</strong>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.pristanek')}}</span>
            <strong>{{ id.cas_pristanka }}</strong>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.pilot')}}</span>
            <strong>{{ id.pilot }}</strong>
          </div>

          <div class="flight-task">
            <span class="label-flight">{{$t('table.naloga')}}</span>
            <strong>{{ id.naloga }}</strong>
          </div>

          <div class="flight-action">
            <i class="fas fa-chevron-right"></i>
          </div>

        </div>

        <div v-if="!FiltriraniPodatki.length" class="empty-state">
          <i class="far fa-folder-open"></i>
          <span>Ni podatkov</span>
        </div>

      </div>

    </section>
    <!-- /ZAKLJUČENI -->
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
    <div class='col-12 p-2'></div>
    <!-- OBRAČUN PODROBNO -->
    <div class="modal modal-kartica" ref="modalObracunMotZapisa" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange" v-if="izbranZapis.length > 0">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOff">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <div class='modal-header'>
            <h5 class="card-title"><i class="fas fa-paper-plane"></i> Izbran zapis (jadralni let)</h5>
          </div>
          <div class="modal-body col-12" style="overflow-y: scroll;">
            <ul class='list-group list-group-flush' v-if="!this.urejanje">
              <li class='list-group-item list-dark'>{{$t('modal.registracija')}} {{izbranZapis[0].registracija}}</li>
              <!-- <li class='list-group-item list-dark'>vlecno: <i class="fas" :class="{'fa-times': !izbranZapis[0].vlecno, 'fa-check': izbranZapis[0].vlecno }"></i></li> -->
              <li class='list-group-item list-dark'>{{$t('modal.pilot')}} {{izbranZapis[0].pilot}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.regVleke')}} {{izbranZapis[0].reg_vleke}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.instruktor')}} {{izbranZapis[0].instruktor}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.namen')}} {{izbranZapis[0].namen}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.naloga')}} {{izbranZapis[0].naloga}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.casVzleta')}} {{izbranZapis[0].cas_vzleta}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.casOdklopa')}} {{izbranZapis[0].cas_odklopa}}</li>
              <!-- <li class='list-group-item list-dark'>cas vziga: {{izbranZapis[0].cas_vziga}}</li> -->
              <!-- <li class='list-group-item list-dark'>cas vzleta: {{izbranZapis[0].cas_vzleta}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.casPristanka')}} {{izbranZapis[0].cas_pristanka}}</li>
              <!-- <li class='list-group-item list-dark'>cas ugasanja: {{izbranZapis[0].cas_ugasanja}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.casLetenja')}} {{izbranZapis[0].cas_letenja}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.casVleke')}} {{izbranZapis[0].cas_vleke}}</li>
              <!-- <li class='list-group-item list-dark'>kilometri: {{izbranZapis[0].kilometri}}</li> -->
              <!-- <li class='list-group-item list-dark'>nocno: {{izbranZapis[0].nocno}}</li> -->
              <!-- <li class='list-group-item list-dark'>vizuelno: {{izbranZapis[0].vizuelno}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modal.opomba')}} {{izbranZapis[0].opomba}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.datumL')}} {{izbranZapis[0].datum}}</li>
              <li class='list-group-item list-dark'>{{$t('modal.datumV')}} {{izbranZapis[0].datum_vnosa}}</li>
            </ul>
            <!-- UREANJE PODATKOV -->
            <ul class='list-group list-group-flush' v-else>
              <div class="hr-with-text p-2">{{$t('edit.titleJ')}}</div>
              <li class='list-group-item list-dark'>{{$t('edit.regJ')}} <span class='text-lorange'>{{izbranZapis[0].registracija}}</span>
                <div class="container">
                  <label class="label-dropdown" for="regLetala">{{$t('labels.registracijaJ')}} <button v-if="regLetala !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="regLetala = ''"> {{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
                    <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
                    <i v-show="dLetalo" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" id="regLetala" @click.prevent="OpenLetalo">{{regLetala}}</button>
                  <transition name="fade">
                    <drop-down @letalo="selectLetalo" :data="Letala" type="letalo" class="drop-down-btn" v-if="dLetalo" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.pilotJ')}} <span class='text-lorange'>{{izbranZapis[0].pilot}}</span>
                <div class="container">
                  <label class="label-dropdown" for="pilotName">{{$t('labels.pilotJ')}} <button v-if="pilotName !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="pilotName = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenPilot()">
                    <i v-show="!dPilot" class="fas fa-chevron-right"></i>
                    <i v-show="dPilot" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5"  id="pilotName" @click.prevent="OpenPilot">{{pilotName}}</button>
                  <transition name="fade">
                    <drop-down @pilot="selectPilot" :data="Piloti" type="piloti" class="drop-down-btn" v-if="dPilot" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.instruktor')}} <span class='text-lorange'>{{izbranZapis[0].instruktor}}</span>
                <div class="container">
                  <label class="label-dropdown" for="instructorName">{{$t('labels.instruktor')}}<button v-if="instructorName !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="instructorName = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenInstructor()">
                    <i v-show="!dInstruktor" class="fas fa-chevron-right"></i>
                    <i v-show="dInstruktor" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="instructorName" @click.prevent="OpenInstructor">{{instructorName}}</button>
                  <transition name="fade">
                    <drop-down @instruktor="selectInstructor" :data="Instruktor" type="instruktor" class="drop-down-btn" v-if="dInstruktor" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.namenJ')}} <span class='text-lorange'>{{izbranZapis[0].namen}}</span>
                <div class="container">
                  <label class="label-dropdown" for="namen">{{$t('labels.namenJ')}} <button v-if="IzbranNamen !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="IzbranNamen = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenNamen()">
                    <i v-show="!dNamen" class="fas fa-chevron-right"></i>
                    <i v-show="dNamen" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" @click.prevent="OpenNamen">{{IzbranNamen}}</button>
                  <transition name="fade">
                    <drop-down @namen="selectNamen" :data="namen" type="namen" class="drop-down-btn" v-if="dNamen" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.nalogaJ')}} <span class='text-lorange'>{{izbranZapis[0].naloga}}</span>
                <div class="container">
                  <label class="label-dropdown" for="naloga">{{$t('labels.nalogaJ')}} <button v-if="IzbranaNaloga !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="IzbranaNaloga = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenNaloga()">
                    <i v-show="!dNaloga" class="fas fa-chevron-right"></i>
                    <i v-show="dNaloga" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="IzbranaNaloga" @click.prevent="OpenNaloga">{{IzbranaNaloga}}</button>
                  <transition name="fade">
                    <drop-down @naloga="selectNaloga" :data="naloga" type="naloga" class="drop-down-btn" v-if="dNaloga" />
                  </transition>
                </div>
              </li>
              <div class="hr-with-text p-2">{{$t('edit.titleM')}}</div>
              <li class='list-group-item list-dark'>{{$t('edit.pilotM')}} <span class='text-lorange'>{{izbranZapis[0].pilot_vleke}}</span>
                <div class="col-12">
                  <div class="container">
                    <label class="label-dropdown" for="pilotName">{{$t('labels.pilotM')}} <button v-if="pilotNameM !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="pilotNameM = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                    <div class="drop-down-icon text-black" @click.prevent="OpenPilotM()">
                      <i v-show="!dPilotM" class="fas fa-chevron-right"></i>
                      <i v-show="dPilotM" class="fas fa-chevron-down"></i>
                    </div>
                    <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="pilotName" @click.prevent="OpenPilotM">{{pilotNameM}}</button>
                    <transition name="fade">
                      <drop-down @pilot="selectPilotM" :data="FilterVlecnihPilotov" type="piloti_vlecni" class="drop-down-btn" v-if="dPilotM" />
                    </transition>
                  </div>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.regM')}} <span class='text-lorange'>{{izbranZapis[0].reg_vleke}}</span>
                <div class="col-12">
                  <div class="container">
                    <label class="label-dropdown" for="regLetala">{{$t('labels.registracijaM')}} <button v-if="regVleka !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="regVleka = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                    <div class="drop-down-icon text-black" @click.prevent="OpenMotorna()">
                      <i v-show="!dLetaloVleka" class="fas fa-chevron-right"></i>
                      <i v-show="dLetaloVleka" class="fas fa-chevron-down"></i>
                    </div>
                    <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="reg_vleke" @click.prevent="OpenMotorna">{{regVleka}}</button>
                    <transition name="fade">
                      <drop-down @motorno="selectLetaloVleke" :data="LetalaMotorna" type="motorno" class="drop-down-btn" v-if="dLetaloVleka" />
                    </transition>
                  </div>
                </div>
              </li>
              <div class="hr-with-text p-2">{{$t('edit.titleS')}}</div>
              <li class='list-group-item list-dark'>{{$t('edit.krajV')}} <span class='text-lorange'>{{izbranZapis[0].kraj_vzleta}}</span>
                <div class="container">
                  <label class="label-dropdown" for="namen">{{$t('labels.vzlet')}} <button v-if="krajVzleta !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="krajVzleta = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenVzlet()">
                    <i v-show="!dVzlet" class="fas fa-chevron-right"></i>
                    <i v-show="dVzlet" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajVzleta" @click.prevent="OpenVzlet">{{krajVzleta}}</button>
                  <transition name="fade">
                    <drop-down @vzlet="selectVzlet" :data="Letalisca" type="vzlet" class="drop-down-btn" v-if="dVzlet" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.krajP')}}<span class='text-lorange'> {{izbranZapis[0].kraj_pristanka}}</span>
                <div class="container">
                  <label class="label-dropdown" for="krajPristanka">{{$t('labels.pristanek')}} <button v-if="krajPristanka !== ''" class="btn btn-sm btn-outline-warning" @click.prevent="krajPristanka = ''">{{$t('buttons.brisiIzbiro')}}</button></label>
                  <div class="drop-down-icon text-black" @click.prevent="OpenPristanek()">
                    <i v-show="!dPristanek" class="fas fa-chevron-right"></i>
                    <i v-show="dPristanek" class="fas fa-chevron-down"></i>
                  </div>
                  <button class="input border-0 rounded-4 p-2 fs-5" id="krajPristanka" @click.prevent="OpenPristanek">{{krajPristanka}}</button>
                  <transition name="fade">
                    <drop-down @pristanek="selectPristanek" :data="Letalisca" type="pristanek" class="drop-down-btn" v-if="dPristanek" />
                  </transition>
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.casV')}} <span class='text-lorange'>{{izbranZapis[0].cas_vzleta}} </span>
                <div class="container">
                  <label :class="{ hidden: poletanje.length > 0 }" class="label-time p-2" for="poletanje">{{$t('labels.poletanje')}}</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Poletanje" id="poletanje" v-model="poletanje" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.casO')}} <span class='text-lorange'>{{izbranZapis[0].cas_odklopa}}</span>
                <div class="container">
                  <label :class="{ hidden: casOdklopa.length > 0 }" class="label-time p-2" for="casOdklopa">{{$t('labels.odklop')}}</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Odklop" id="casOdklopa" v-model="casOdklopa" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.casPJ')}} <span class='text-lorange'>{{izbranZapis[0].cas_pristanka}}</span>
                <div class="container">
                  <label :class="{ hidden: pristanek.length > 0 }" class="label-time p-2" for="pristanek">{{$t('labels.pristanekJ')}}</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Pristanek" id="pristanek" v-model="pristanek" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.casPM')}} <span class='text-lorange'>{{izbranZapis[0].cas_pristanka_vleka}}</span>
                <div class="container">
                  <label :class="{ hidden: pristanekM.length > 0 }" class="label-time p-2" for="pristanek">{{$t('labels.pristanekM')}}</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Pristanek" id="pristanek" v-model="pristanekM" required />
                </div>
              </li>
              <li class='list-group-item list-dark'>{{$t('edit.opomba')}}<span class='text-lorange'>{{izbranZapis[0].opomba}}</span>
                <div class="container">
                  <label :class="{ hidden: opomba.length > 0 }" class="label" for="opomba">{{$t('labels.opomba')}}</label>
                  <textarea class="input-comment border-0 rounded-4 p-2 fs-5" type="textarea" id="opomba" v-model="opomba" rows="6" autocomplete="off">
                                    </textarea>
                </div>
              </li>
            </ul>
          </div>
          <div class="modal-footer col-12">
            <!-- UREDI GUMB -->
            <button class="btn btn-outline-warning"
                    :class="{'disabled': LahkoUreja() === false }"
                    v-if="!this.urejanje"
                    @click.prevent="UrediZapis(izbranZapis[0].id)"
            >
              <i class="fas fa-user-edit"></i>
              <s v-if="LahkoUreja() === false" >{{$t('buttons.urediPodatke')}} </s>
              <span v-if="LahkoUreja()">{{$t('buttons.urediPodatke')}} </span>
            </button>
            <!-- POSODOBI GUMB -->
            <button class="btn btn-outline-success"
                    v-else
                    @click.prevent="PosodobiZapis()"
                    :disabled="dodajam"
            >
              <i class="fas fa-sync-alt" :class="{'fa-spin': dodajam}"></i>{{$t('buttons.posodobiPodatke')}}
            </button>
            &nbsp;
            <!-- BRISI GUMB -->
            <button v-if="!this.urejanje" class="btn btn-outline-danger"
                    :class="{'disabled': LahkoBrise() === false }"
                    @click.prevent="PotrdiIzbris(izbranZapis[0].id, izbranZapis[0].p_logbook_jadralna_id, izbranZapis[0].id_motorno)"
            >
              {{$t('buttons.izbrisiZapis')}}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL NEZAKLJUČENI LETI -->
    <div class="modal modal-kartica" ref="modalObracunOdprti" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange" v-if="izbranZapis.length > 0">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="DetailsOffZ">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <div class='modal-header'>
            <h5 class="card-title"><i class="fas fa-plane"></i> {{$t('modalNL.title')}}</h5>
          </div>
          <div class="modal-body col-12" style="overflow-y: scroll;">
            <ul class='list-group list-group-flush'>
              <li class='list-group-item list-dark'>{{$t('modalNL.regJ')}} {{izbranZapis[0].registracija}}</li>
              <!-- <li class='list-group-item list-dark'>vlecno: <i class="fas" :class="{'fa-times': !izbranZapis[0].vlecno, 'fa-check': izbranZapis[0].vlecno }"></i></li> -->
              <li class='list-group-item list-dark'>{{$t('modalNL.pilotJ')}} {{izbranZapis[0].pilot}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.regM')}} {{izbranZapis[0].reg_vleke}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.instruktor')}} {{izbranZapis[0].instruktor}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.namen')}} {{izbranZapis[0].namen}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.naloga')}} {{izbranZapis[0].naloga}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.casV')}} {{izbranZapis[0].cas_vzleta}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.casO')}} {{izbranZapis[0].cas_odklopa}}</li>
              <!-- <li class='list-group-item list-dark'>cas vziga: {{izbranZapis[0].cas_vziga}}</li> -->
              <!-- <li class='list-group-item list-dark'>cas vzleta: {{izbranZapis[0].cas_vzleta}}</li> -->
              <li class='list-group-item list-dark'>
                <div class="container">
                  <label :class="{ hidden: pristanek.length > 0 }" class="label-time p-2" for="pristanek">{{$t('modalNL.pristanekJ')}}</label>
                  <input class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Pristanek" ref="pristanekZ" v-model="pristanek" required />
                </div>
              </li>
              <!-- <li class='list-group-item list-dark'>cas ugasanja: {{izbranZapis[0].cas_ugasanja}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modalNL.casVL')}} {{izbranZapis[0].cas_vleke}}</li>
              <!-- <li class='list-group-item list-dark'>kilometri: {{izbranZapis[0].kilometri}}</li> -->
              <!-- <li class='list-group-item list-dark'>nocno: {{izbranZapis[0].nocno}}</li> -->
              <!-- <li class='list-group-item list-dark'>vizuelno: {{izbranZapis[0].vizuelno}}</li> -->
              <li class='list-group-item list-dark'>{{$t('modalNL.opomba')}} {{izbranZapis[0].opomba}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.datumL')}} {{izbranZapis[0].datum}}</li>
              <li class='list-group-item list-dark'>{{$t('modalNL.datumV')}} {{izbranZapis[0].datum_vnosa}}</li>
            </ul>
          </div>
          <!-- ZAKLJUČI GUMB -->
          <div class="modal-footer col-12">
            <button class="btn btn-outline-success"
                    :class="{'disabled': LahkoZakljuci() === false }"
                    @click.prevent="ZakljuciLet()" :disabled="dodajam"
            >
              <i class="fas fa-sync-alt" :class="{'fa-spin': dodajam}"></i> {{$t('buttons.zakljuciLet')}}
            </button>&nbsp;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.flight-section-pregled {
  background: #151922;

  border: 1px solid #292f3b;
  border-radius: 14px;

  overflow-y: scroll;
  max-height: 90vh;
  box-shadow: 0 8px 30px rgba(0, 0, 0, .12);
}
.flight-item-pregled {
  display: grid;

  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr auto;

  align-items: center;

  gap: 20px;

  padding: 13px 15px;

  border-radius: 9px;

  cursor: pointer;

  transition:
      background .2s ease,
      transform .2s ease;
  border: 1px solid gray;
  margin-top: 0.5rem;
}
.flight-item-pregled:hover {
  background: #1e2530;
}
.label-flight {
  display: block;

  margin-bottom: 3px;

  color: #667181;

  font-size: .68rem;
  text-transform: uppercase;
  letter-spacing: .04em;
}
@media (max-width: 900px) {

  .flight-item-pregled {
    grid-template-columns: 1fr 1fr;
    gap: 2px;
    position: relative;
    padding-right: 55px;
    border-bottom: 1px solid gray;
  }

  .flight-action {
    position: absolute;
    right: 15px;
  }
}


@media (max-width: 650px) {

  .flight-item-pregled {
    grid-template-columns: 1fr;
  }
}
</style>